import { render } from "./Checkout.vue?vue&type=template&id=2612e0c4"
import script from "./Checkout.vue?vue&type=script&lang=js"
export * from "./Checkout.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zhouyi/workplace/node/djweb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__